export default __webpack_public_path__ + "static/media/logo-mobile-nav-2b2a29.d0f55ce3.svg";